import { atom } from 'recoil';

export const trackSliceState = atom({
  key: 'trackSliceState',
  default: 100,
});
